import { Component } from '@angular/core';
import { BaseSuccessComponent } from '../base-success/base-success.component';
import { NgOptimizedImage } from '@angular/common';
import { DownloadAppButtonsComponent } from '../../../shared/components/download-app-buttons/download-app-buttons.component';
import { RouterSwitchBtnComponent } from '../../../shared/components/router-switch-btn/router-switch-btn.component';

@Component({
  selector: 'app-phone-success',
  imports: [NgOptimizedImage, DownloadAppButtonsComponent, RouterSwitchBtnComponent],
  templateUrl: '../base-success/base-success.component.html',
})
export class PhoneSuccessComponent extends BaseSuccessComponent {
  protected override subTitle: string = 'Phone number has been updated.';
}
